import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    @import 'tailwindcss/base';
    @import 'tailwindcss/components';
    @import 'tailwindcss/utilities';

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    input[type="password"]::-ms-reveal,
    input[type="password"]::-ms-clear,
    input[type="password"]::-webkit-credentials-auto-fill-button,
    input[type="password"]::-webkit-input-password-toggle-button,
    input[type="password"]::-webkit-input-clear-button {
        display: none !important;
    }

    input[type="password"]::-moz-password-reveal {
        display: none !important;
    }

    .MuiInputAdornment-root {
        .MuiIconButton-root {
            color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
            &:hover {
                background-color: rgba(255, 255, 255, 0.08);
            }
        }
    }

    :root {
        font-size: 16px;
        /* Variáveis CSS para altura da viewport */
        --vh: 1vh;
        --real-vh: 1vh;
        --safe-area-inset-bottom: env(safe-area-inset-bottom, 50px);
        --safe-area-inset-top: env(safe-area-inset-top, 0px);

        @media (max-width: ${({ theme }) => theme.BREAKPOINTS.WIDTH.MD}) , (max-height: ${({ theme }) => theme.BREAKPOINTS.HEIGHT.MEDIUM}) {
            font-size: 14px;
        };

        @media (max-width: ${({ theme }) => theme.BREAKPOINTS.WIDTH.SM}) , (max-height: ${({ theme }) => theme.BREAKPOINTS.HEIGHT.SMALL}) {
            font-size: 12px;
        };

        @media (max-width: ${({ theme }) => theme.BREAKPOINTS.WIDTH.XS}) , (max-height: ${({ theme }) => theme.BREAKPOINTS.HEIGHT.EXTRA_SMALL}) {
            font-size: 10px;
        };
    }

    body {
        background-color: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
        color: ${({ theme }) => theme.COLORS.ERROR};
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    a {
        text-decoration: none;
    }

    button {
        font-family: 'Roboto', serif;
        font-size: 1rem;
        outline: none;
        transition: all 0.2s ease-in-out;
    }

    button, a {
        cursor: pointer;
        transition: filter 0.2s, transform 0.2s ease-in-out;
    }

    button:hover, a:hover {
        filter: brightness(0.9);
        //transform: scale(1.03);
    }

    button:active, a:active {
        //transform: scale(1.01);
    }

    ::-webkit-scrollbar {
        width: 0.4rem;
        transition: all 0.2s ease-in-out;
    }

    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.COLORS.GRAY_50};
        border-radius: 10px;
        border: 8px solid transparent;
        transition: all 0.2s ease-in-out;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: ${({ theme }) => theme.COLORS.GRAY_40};
        transform: scaleX(2);
        transform-origin: left;
    }

    #filter-drawer {
        background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY} !important;
        .ant-drawer-body {
            padding: 0;
        }
    }

    button.ant-drawer-close {
        color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY} !important;
    }

    .modal_vox {
        .ant-modal-content {
            padding: 12px 0 ;
        }
    }

    .centered_div-empty {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 4px;
        p {
            color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
            font-size: 12px;
        }
    }

    .cursor-not-allowed {
        cursor: not-allowed;
    }

    .ant-spin-dot i {
        background-color: ${({ theme }) => theme.COLORS.PRIMARY} !important;
    }

    .react-tel-input .country-list .country {
        background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
        color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
    }

    .react-tel-input .country-list .country:hover {
        background-color:  ${({ theme }) => theme.COLORS.GRAY_50} !important;
        color:  ${({ theme }) => theme.COLORS.TEXT_PRIMARY} !important;
    }

    .react-tel-input .country-list .country.highlight {
        background-color: ${({ theme }) => theme.primary} !important;
        color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY} !important;
    }

    .react-tel-input .flag-dropdown {
        background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
        border: 1px solid ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
    }

    .react-tel-input .flag-dropdown:hover {
        background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
        border: 1px solid ${({ theme }) => theme.COLORS.TEXT_PRIMARY};
    }

    .react-tel-input .flag-dropdown:disabled {
        color: ${({ theme }) => theme.COLORS.GRAY_40};
        border-color: ${({ theme }) => theme.COLORS.GRAY_80};
    }

    .MuiOutlinedInput-root.Mui-disabled {
        cursor: not-allowed;
        .MuiOutlinedInput-notchedOutline {
            border-color: ${({ theme }) => theme.COLORS.GRAY_80} !important;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY} inset !important;
        -webkit-text-fill-color: ${({ theme }) => theme.COLORS.TEXT_PRIMARY} !important;
        transition: background-color 5000s ease-in-out 0s;
    }

    .simplebar-scrollbar::before {
        background-color: ${({ theme }) => theme.COLORS.GRAY_50};
        border-radius: 10px;
        opacity: 0.5;
        transition: all 0.2s ease-in-out;
    }

    .simplebar-scrollbar:hover::before {
        background-color: ${({ theme }) => theme.COLORS.GRAY_40};
        opacity: 1;
        width: 1rem !important;
    }

    .simplebar-track {
        background-color: transparent;
    }

    .simplebar-track.simplebar-vertical {
        width: 0.25rem;
    }

    .simplebar-track.simplebar-vertical:hover {
        width: 1rem;
    }

    /* Força o iframe do Jitsi a ocupar toda a tela visível no mobile, sem sobrepor a barra do navegador */
     @media (max-width: 600px) {
      .jitsi-iframe,
      iframe[id^='jitsiConferenceFrame'] {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: calc(100vh - var(--safe-area-inset-bottom)) !important;
        min-width: 100vw !important;
        min-height: 80vh !important;
        max-width: 100vw !important;
        max-height: calc(100vh - var(--safe-area-inset-bottom)) !important;
        border: none !important;
        z-index: 2001 !important;
        background: black !important;
        box-sizing: border-box !important;
         // Aumenta o padding para garantir espaço para barras em todos os mobiles
        padding-bottom: calc(15vh + env(safe-area-inset-bottom, 0px)) !important;
      }
    }

     /* Força o iframe do Jitsi a ocupar toda a tela no mobile */
    @media (max-width: 600px) {
      .jitsi-iframe,
      iframe[id^='jitsiConferenceFrame'] {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        min-width: 100vw !important;
        min-height: 80vh !important;
        max-width: 100vw !important;
        max-height: 90vh !important;
        border: none !important;
        z-index: 2001 !important;
        background: black !important;
      }
    }

    /* Estilos específicos para Safari no iOS */
    @supports (-webkit-touch-callout: none) {
         iOS Safari
        .mobile-safe-height {
            height: calc(100vh - var(--safe-area-inset-bottom) - var(--safe-area-inset-top));
        }

        .mobile-safe-bottom {
            bottom: calc(var(--safe-area-inset-bottom) + 7vh);
        }

        .mobile-safe-top {
            top: calc(var(--safe-area-inset-top) + 56px);
        }
    }

    /* Estilos para dispositivos móveis com barra de navegação */
    @media (max-width: 1023px) {
        .mobile-viewport-height {
            height: calc(var(--real-vh, 100vh) - 56px);
        }

        .mobile-bottom-nav {
            bottom: 0;
            padding-bottom: var(--safe-area-inset-bottom);
        }

        .mobile-content-area {
            padding-bottom: calc(7vh + var(--safe-area-inset-bottom));
            height: 83vh
        }

        .mobile-fixed-bottom {
            bottom: calc(7vh + var(--safe-area-inset-bottom));
        }
    }

    /* Estilos específicos para iPhone Safari */
    @media screen and (max-width: 1023px) and (-webkit-min-device-pixel-ratio: 2) {
        .iphone-safe-height {
            height: calc(100vh - var(--safe-area-inset-bottom) - var(--safe-area-inset-top));
        }

        .iphone-bottom-nav {
            bottom: var(--safe-area-inset-bottom);
        }

        .iphone-content-area {
            padding-bottom: calc(7vh + var(--safe-area-inset-bottom));
        }
    }
`;

export const SearchService = {
  height: '1.5rem',
  '& .MuiInputBase-root': {
    minHeight: '1.5rem',
    padding: '2px',
  },
  '& .MuiInputBase-input': {
    height: '1.5rem',
    padding: '0 8px',
    fontSize: '0.8rem',
  },
};
